import { ComponentRenderer, Page } from "@ludens-reklame/rubics-v3-react/page";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store/types";

export const App: React.FC<{ store: Store; renderer: ComponentRenderer }> = ({
  store,
  renderer,
}) => {
  return (
    <Page store={store} useCartContext renderComponent={renderer}>
      {({ header, main, footer }) => {
        const verticalMenuIndex = header.findIndex((component) =>
          component.key?.includes("verticalmenu")
        );

        if (verticalMenuIndex !== -1) {
          const verticalMenuSection = header.splice(verticalMenuIndex, 1);

          return (
            <div>
              {header}
              <div className="main-wrapper">
                <div className="vertical-menu-container">
                  {verticalMenuSection}
                </div>
                <main className="main-content mw w-100 m-auto">{main}</main>
              </div>
              {footer}
            </div>
          );
        }

        return (
          <>
            {header}
            <main>{main}</main>
            {footer}
          </>
        );
      }}
    </Page>
  );
};
